import React, { useState } from "react";
import "./Contact.css";
import Footer from "../components/Footer.jsx";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you for contacting us!");
    setFormData({ name: "", email: "", subject: "", message: "" });
  };

  return (
    <div className="contact-page-wrapper">
      {/* Transparent Hero Section */}
      <section className="contact-hero-section">
        <div className="contact-hero-content">
          <h1>Contact <span>Us</span></h1>
          <p>We’re here to help. Reach out to us for any questions or support.</p>
        </div>
      </section>

      {/* Main Contact Container */}
      <div className="contact-container">
        <div className="contact-content-grid">
          {/* Left: Form */}
          <div className="contact-form-section">
            <h2>Send a Message</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-field">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-field">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-field">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-field">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>
              <button type="submit" className="submit-btn">Send Message</button>
            </form>
          </div>

          {/* Right: Contact Info */}
          <div className="contact-info-section">
            <h2>Get in Touch</h2>
            <p><strong>Address:</strong> Chinchua Tea Estate, Chinchula Road, Kalchini, 735217, West Bengal, India</p>
            <p><strong>Phone:</strong> +91 9932144384</p>
            <p><strong>Email:</strong> lukasdewt@yahoo.com</p>

            {/* Map */}
            <div className="contact-map">
              <iframe
                title="NGO Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3650.735987!2d88.816593!3d26.661774!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39e41c7e8f3a4fd7%3A0x123456789abcdef0!2sChinchua%20Tea%20Estate!5e0!3m2!1sen!2sin!4v1686851234567!5m2!1sen!2sin"
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Contact;
